import { render, staticRenderFns } from "./NsuManager.vue?vue&type=template&id=2d80d349&scoped=true&"
import script from "./NsuManager.vue?vue&type=script&lang=js&"
export * from "./NsuManager.vue?vue&type=script&lang=js&"
import style0 from "./NsuManager.vue?vue&type=style&index=0&id=2d80d349&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d80d349",
  null
  
)

export default component.exports